import { ChangeEvent } from 'react';

import {
  Box,
  Checkbox,
  Collapse,
  FormControl,
  FormControlLabel,
  InputLabel,
  Radio,
  TextField,
  Typography,
} from '@material-ui/core';

import {
  useAccountDetailsContext,
  useAuthConnectionsContext,
} from './CreateAccountFormProvider';
import type { AuthConnection } from './hooks/useCreateAccount';

const AUTH_CONNECTION_OPTIONS: { connection: AuthConnection; label: string }[] =
  [
    { connection: 'passwordAuthConnection', label: 'E-mail' },
    { connection: 'googleAuthConnection', label: 'Google' },
  ];

export const AuthConnectionsSection = () => {
  const { accountDetails, setField } = useAccountDetailsContext();
  const {
    hasSelectedAuthConnection,
    userAuthConnection,
    toggleAuthConnection,
  } = useAuthConnectionsContext();

  return (
    <>
      <Typography variant="body1" color="textSecondary" gutterBottom>
        Choose how people in your company will log in to Confidence.
      </Typography>
      <FormControl component="fieldset">
        {AUTH_CONNECTION_OPTIONS.map(({ connection, label }) => (
          <FormControlLabel
            key={connection}
            value={connection}
            control={
              <Checkbox
                color="primary"
                checked={accountDetails.authConnections[connection]}
                required={!hasSelectedAuthConnection}
                disabled={userAuthConnection === connection}
              />
            }
            onChange={toggleAuthConnection(connection)}
            label={`${label} ${
              userAuthConnection === connection
                ? '(you used this when signing up)'
                : ''
            }`}
          />
        ))}
      </FormControl>

      <Collapse in={accountDetails.authConnections.googleAuthConnection}>
        <Box marginTop={4}>
          <InputLabel>Google login options</InputLabel>
          <FormControl component="fieldset">
            <FormControlLabel
              value="invite-only"
              control={
                <Radio
                  color="primary"
                  checked={accountDetails.loginDomain === undefined}
                />
              }
              onChange={() => setField({ loginDomain: undefined })}
              label="Only invited users can log in"
            />
            <FormControlLabel
              value="domain"
              control={
                <Radio
                  color="primary"
                  checked={accountDetails.loginDomain !== undefined}
                />
              }
              onChange={() => setField({ loginDomain: '' })}
              label="Allow everyone from a specific domain to login"
            />
            <Collapse in={accountDetails.loginDomain !== undefined}>
              <TextField
                label="Google login domain"
                variant="outlined"
                name="google-login-domain"
                placeholder="For example spotify.com"
                value={accountDetails.loginDomain ?? ''}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  setField({ loginDomain: e.target.value })
                }
                fullWidth
              />
            </Collapse>
          </FormControl>
        </Box>
      </Collapse>
    </>
  );
};
